if (!customElements.get('product-lightbox')) {
  customElements.define('product-lightbox', class ProductLightbox extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.product-lightbox__close').addEventListener('click', () => this.close())
      this.initSwiper()
      window.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && this.classList.contains('is-visible')) this.close()
      })
    }

    initSwiper() {
      const lightbox_carousel = {
        class: 'product-lightbox',
        config: {
          a11y: {
            containerMessage: 'Lightbox slider',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          on: {
            slideChange: (swiper) => {
              window.carousels[".main-product__main-carousel"].slideTo(swiper.activeIndex)
            }
          },
          loop: true,
          freeMode: false,
          slidesPerView: 1,
          centerMode: true,
          grabCursor: true,
          slideToClickedSlide: true,
          pagination: {
            el: ".product-lightbox__pagination",
          },
          navigation: {
            nextEl: '.product-lightbox__btn--next',
            prevEl: '.product-lightbox__btn--prev'
          }
        }
      }
      window.swiperInstances = window.swiperInstances ? { ...swiperInstances, lightbox_carousel} : { lightbox_carousel }

    }

    show() {
      this.classList.add('is-visible')
    }

    close() {
      this.classList.remove('is-visible')
    }

  })
}